export const models = [
  { value: "latest", label: "Latest (GPT-5)" },

  // GPT-5 (docs-listed)
  { value: "gpt-5", label: "GPT-5" },         // flagship
  { value: "gpt-5-mini", label: "GPT-5 Mini" },
  { value: "gpt-5-nano", label: "GPT-5 Nano" },

  // 2025 releases
  { value: "o4-mini", label: "OpenAI o4-mini" }, // Apr 16, 2025
  { value: "o3", label: "OpenAI o3" },           // 2024→2025 roll-out
  { value: "gpt-4.1", label: "GPT-4.1" },
  { value: "gpt-4.1-mini", label: "GPT-4.1 Mini" },
  { value: "gpt-4.1-nano", label: "GPT-4.1 Nano" },

  // 2024 era
  { value: "gpt-4o", label: "GPT-4o" },
  { value: "gpt-4o-mini", label: "GPT-4o Mini" },
  { value: "gpt-4-turbo", label: "GPT-4 Turbo" },
  { value: "gpt-4", label: "GPT-4" },

  // Legacy
  { value: "gpt-3.5-turbo", label: "GPT-3.5 Turbo" }
];
